import ArchiveIcon from "@mui/icons-material/Archive";
import EditIcon from "@mui/icons-material/Edit";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { useNavigate } from "react-router-dom";

import {
  ProductUpdate,
  ProductUpdateEditPayload,
  ProductUpdatePathParams,
  ProductUpdatePcm,
} from "api/memberPortal/product/productUpdate/productUpdate.types";
import ActionsCell from "components/MUI/DataGrid/Cells/Actions/Actions.cell";
import IconMenuItem from "components/MUI/DataGrid/Cells/Actions/IconMenuItem";

interface ProductUpdateActionsCellProps<
  T extends ProductUpdate | ProductUpdatePcm,
> {
  productUpdate: T;
  onArchive: (_payload: ProductUpdatePathParams) => void;
  onUnarchive: (_payload: ProductUpdateEditPayload) => void;
  getParentId: (_payload: T) => number;
}

const ProductUpdateActionsCell = <T extends ProductUpdate | ProductUpdatePcm>({
  productUpdate,
  onArchive,
  onUnarchive,
  getParentId,
}: ProductUpdateActionsCellProps<T>) => {
  const { id, active } = productUpdate;

  const navigate = useNavigate();

  const handleArchive = async () => {
    await onArchive({
      parentId: getParentId(productUpdate),
      updateId: productUpdate.id,
    });
  };

  const handleUnarchive = async () => {
    await onUnarchive({
      parentId: getParentId(productUpdate),
      updateId: productUpdate.id,
      body: {
        active: true,
      },
    });
  };

  const handleEdit = () => {
    navigate(`${id}/edit/`);
  };

  return (
    <ActionsCell id={`update-${id}`}>
      <IconMenuItem Icon={EditIcon} label="Edit" onClick={handleEdit} />
      <IconMenuItem
        Icon={ArchiveIcon}
        label="Archive"
        onClick={handleArchive}
        enabled={active}
      />
      <IconMenuItem
        Icon={UnarchiveIcon}
        label="Unarchive"
        onClick={handleUnarchive}
        enabled={!active}
      />
    </ActionsCell>
  );
};
export default ProductUpdateActionsCell;
